export default __webpack_public_path__ + "imgs/busywork.c8b68bdfbe524d73211081b9f13b0eef.svg";